import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import useRut from '../../../../hooks/useRut';
import { setCleanTextAreaError } from '../../../../utils/utils';
import { SurveyDataForm } from '../../../../app/models/Survey';
import { EventTypeListItem } from '../../../../app/models/EventType';
import { JobTitle } from '../../../../app/models/JobTitle';

interface GeneralProps {
    surveyForm: SurveyDataForm;
    eventTypes: EventTypeListItem[];
    job_titles: JobTitle[];
    setSurveyForm: (surveyForm: SurveyDataForm) => void;
    errorFields?: any;
}

const SurveyForm = ({
    surveyForm,
    setSurveyForm,
    eventTypes,
    job_titles,
    errorFields
}: GeneralProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    const { formatRut } = useRut();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        setSurveyForm({ ...surveyForm, [name]: value });
    };


    const handleCheckChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name } = event.target;
        setSurveyForm({
            ...surveyForm,
            is_mandatory: !surveyForm.is_mandatory
        });
    };

    const MapperOptions = (items: any[]) => {
        return items.map((item) => ({
            value: item.id,
            label: item.name
        }));
    };

    if (!surveyForm) return null;

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Título</label>

                    <input
                        className={`form-control ${fieldHasError('title')}`}
                        type="text"
                        name="title"
                        id="title"
                        value={surveyForm.title}
                        onChange={handleChange}
                        placeholder="Ingrese título"
                        onFocus={() => onFocusRemove('title')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('title')}
                    </div>
                </div>
            </div>
            <div className="mb-2 row">
                <div className="col-md-12">
                <label className="col-form-label">Descripción</label>
                <textarea
                        className={`form-control ${fieldHasError('description')}`}
                        name="description"
                        id="description"
                        value={surveyForm.description}
                        onChange={handleChange}
                        placeholder="Ingrese descripción"
                        onFocus={setCleanTextAreaError}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('description')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                <label className="col-form-label">Tipos de Eventos</label>
                    <SelectTwo
                        name="event_types"
                        id="event_types"
                        inputValue={surveyForm.event_types}
                        options={MapperOptions(eventTypes)}
                        hasError={fieldHasError('event_types') !== ''}
                        onChange={(value: any) =>
                            setSurveyForm({
                                ...surveyForm,
                                event_types: value
                            })
                        }
                        isSortable={true}
                        isMulti={true}
                        placeholder={'Seleccione los tipos de eventos'}
                        onFocus={() => onFocusRemove('event_types')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('event_types')}
                    </div>
                </div>
            </div>



            <div className="mb-4 row">
                <div className="col-md-12">
                <label className="col-form-label">Puesto de Trabajos</label>
                    <SelectTwo
                        name="job_titles"
                        id="job_titles"
                        inputValue={surveyForm.job_titles}
                        options={MapperOptions(job_titles)}
                        hasError={fieldHasError('job_titles') !== ''}
                        onChange={(value: any) =>
                            setSurveyForm({
                                ...surveyForm,
                                job_titles: value
                            })
                        }
                        isSortable={true}
                        isMulti={true}
                        placeholder={'Seleccione los puesto de trabajo'}
                        onFocus={() => onFocusRemove('job_titles')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('job_titles')}
                    </div>
                </div>
            </div>


            <div className="mb-4 row">
                <div className="col-6">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="is_mandatory"
                            value="true"
                            checked={surveyForm.is_mandatory}
                            id="is_mandatory"
                            onChange={handleCheckChange}
                        />
                        <label className="form-check-label" htmlFor="is_mandatory">
                            Obligatorio
                        </label>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="is_mandatory"
                            value="false"
                            checked={!surveyForm.is_mandatory}
                            id="is_indefinite"
                            onChange={handleCheckChange}
                        />
                        <label className="form-check-label" htmlFor="is_mandatory">
                            No Obligatorio
                        </label>
                    </div>
                </div>
            </div>



            {surveyForm.is_mandatory && <div className="mb-2 row">
                <label className="col-form-label col-md-6">Notificar cada {surveyForm.notification_time} minutos</label>
                <div className="col-md-6">
                    
                    <input
                        type="number"
                        className={`form-control ${fieldHasError('notification_time')}`}
                        name="notification_time"
                        id="notification_time"
                        value={surveyForm.notification_time}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('notification_time')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('notification_time')}
                    </div>
                </div>
            </div>}

            

        </>
    );
};

export default SurveyForm;
